import { CreateSnapshotExportPayload, SnapshotExport } from "./types";
import { analysisApi } from "./analysis";

/** Asynchronous snapshot exports (CSV/XLSX). */
export const exportsApi = analysisApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    createSnapshotExport: builder.mutation<SnapshotExport, CreateSnapshotExportPayload>({
      query: data => ({
        url: "/pf-mainweb/business-reports/snapshot-exports",
        method: "POST",
        data,
      }),
    }),
    getSnapshotExport: builder.query<SnapshotExport, string>({
      query: id => ({
        url: `/pf-mainweb/business-reports/snapshot-exports/${id}`,
      }),
    }),
  }),
});

export const { useCreateSnapshotExportMutation, useGetSnapshotExportQuery } = exportsApi;
